import React, { forwardRef } from 'react';
import Typography from '../typography/Typography';
import { ICustomTextarea } from '../../types/textarea';
import styles from './textarea.module.scss';

const Textarea = forwardRef<HTMLTextAreaElement, ICustomTextarea>(
  (
    {
      name,
      onChange,
      onBlur,
      onWheel,
      onFocus,
      label,
      className = '',
      defaultValue = '',
      rows = undefined,
      disabled = false,
      placeholder = '',
      nonEditable = false,
      minHeight = 148,
      upperCase = false,
      ...props
    },
    ref,
  ) => {
    const classBase = 'custom-textarea';
    let classes = styles[classBase];

    if (disabled) classes += ` ${styles[`${classBase}-disabled`]}`;
    if (nonEditable) classes += ` ${styles[`${classBase}-non-editable`]}`;
    if (upperCase) classes += ` ${styles.uppercase}`;

    return (
      <div className={`${styles['custom-textarea-wrapper']} ${className} ${nonEditable ? styles['non-editable'] : ''}`}>
        <textarea
          style={{ height: `${minHeight}px` }}
          name={name}
          rows={rows}
          defaultValue={defaultValue}
          onChange={onChange}
          onBlur={onBlur}
          onWheel={onWheel}
          onFocus={onFocus}
          placeholder={placeholder}
          className={`${classes} default-font`}
          disabled={disabled || nonEditable}
          ref={ref}
          data-testid={classBase}
          {...props}
        />
        <Typography variant="caption">{label || ''}</Typography>
      </div>
    );
  },
);

export default Textarea;

Textarea.displayName = 'Textarea';
